(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-counts"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function () {
    // Create overlay element
    const overlay = document.createElement("div");
    overlay.classList.add("vib-unique-overlay");
    document.body.appendChild(overlay);

    document.addEventListener("click", function (event) {
      const button = event.target.closest(".learn-more");
      const close = event.target.closest(".close-popup");
      const activePopup = document.querySelector(".popup.active-popup");

      // Show popup
      if (button) {
        const popup = document.getElementById(button.dataset.popupId);
        if (popup) {
          popup.style.display = "flex";
          popup.classList.add("active-popup");
          overlay.style.display = "block"; // Show overlay
          document.body.classList.add("no-scroll"); // Disable scrolling
        }
      }

      // Close popup
      else if (close) {
        const popup = document.getElementById(close.dataset.popupId);
        if (popup) {
          popup.style.display = "none";
          popup.classList.remove("active-popup");
          overlay.style.display = "none"; // Hide overlay
          document.body.classList.remove("no-scroll"); // Enable scrolling
        }
      }

      // Close popup on outside click
      else if (activePopup && !activePopup.contains(event.target)) {
        activePopup.style.display = "none";
        activePopup.classList.remove("active-popup");
        overlay.style.display = "none"; // Hide overlay
        document.body.classList.remove("no-scroll"); // Enable scrolling
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
